import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { StorageService } from '@services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public config: object;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) { }

  public async load(): Promise<any> {
    this.config = await firstValueFrom(this.http.get('/api/config'));
    this.storageService.setSession('ApiBasePath', this.getValue('ApiBasePath'));

    return this.config;
  }

  public getValue(key: string): any {
    return this.config[key];
  }
}
